import classnames from "classnames";
import { Link, Props } from "./types";

export const Menu = ({
  links,
  paddingX,
  paddingY,
  onClickEvent
}: Props) => {
  return (
    <nav className="inline-block" role="navigation" aria-label="Main navigation">
      {links.map((item: Link, index: number) => (
        <button 
          key={index}
          onClick={() => {
            onClickEvent({
              name: item.name,
              group_id: item.id ? item.id : 0,
              index: index
            }); 
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClickEvent({
                name: item.name,
                group_id: item.id ? item.id : 0,
                index: index
              });
            }
          }}
          aria-current={item.activeClass ? "page" : undefined}
          aria-pressed={item.activeClass}
          className={classnames(
            "uppercase text-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg",
            { "opacity-100": item.activeClass },
            { "opacity-50": !item.activeClass },
            { "px-7": !paddingX },
            paddingX,
            { "py-5": !paddingY },
            paddingY,
          )}
        >
          { item.label || item.name }
        </button>
      ))}
    </nav>
  );
};
